import React, { useState, useEffect } from 'react';
import { getSnapshot, sendSnapshotEmail } from '../utils/api';

export default function SnapshotDetail({ snapshotId, onBack }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [emailTo, setEmailTo] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    getSnapshot(snapshotId).then(d => { setData(d); setEmailTo(d?.emailConfig?.email || ''); }).catch(console.error).finally(() => setLoading(false));
  }, [snapshotId]);

  const handleSendEmail = async () => {
    if (!emailTo) return alert('Enter an email address');
    setSending(true);
    try {
      await sendSnapshotEmail(snapshotId, emailTo);
      alert(`Email sent to ${emailTo}!`);
    } catch (err) { alert(err.message); }
    setSending(false);
  };

  if (loading) return <p>Loading snapshot...</p>;
  if (!data) return <p>Snapshot not found. <button onClick={onBack}>Back</button></p>;

  return (
    <div>
      <button onClick={onBack} style={{ padding: '4px 12px', marginBottom: 12, cursor: 'pointer' }}>← Back to History</button>
      <h2 style={{ margin: '0 0 4px' }}>{data.dashboardName}</h2>
      <p style={{ fontSize: 13, color: '#666', margin: '0 0 12px' }}>
        {data.industry} · {data.role} · {data.interests}<br />
        {data.startDate} → {data.endDate} · {data.items?.length} items · {data.createdAt?.slice(0, 16).replace('T', ' ')}
      </p>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 16 }}>
        <input type="email" placeholder="Send to email..." value={emailTo} onChange={(e) => setEmailTo(e.target.value)}
          style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13, width: 250 }} />
        <button onClick={handleSendEmail} disabled={sending}
          style={{ padding: '6px 14px', background: '#ec7211', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>
          {sending ? 'Sending...' : '📧 Send Email'}
        </button>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        <thead>
          <tr style={{ background: '#f0f0f0', textAlign: 'left' }}>
            <th style={{ padding: 8, width: 40 }}>Score</th>
            <th style={{ padding: 8 }}>Title</th>
            <th style={{ padding: 8, width: 100 }}>Date</th>
            <th style={{ padding: 8 }}>Why it matters</th>
          </tr>
        </thead>
        <tbody>
          {(data.items || []).map((item, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: 8, textAlign: 'center' }}>
                <span style={{
                  display: 'inline-block', width: 28, height: 28, lineHeight: '28px', borderRadius: '50%', textAlign: 'center',
                  background: item.score >= 8 ? '#1b8901' : item.score >= 5 ? '#ec7211' : '#aaa', color: '#fff', fontWeight: 'bold', fontSize: 13,
                }}>{item.score}</span>
              </td>
              <td style={{ padding: 8 }}>
                <a href={item.link} target="_blank" rel="noreferrer" style={{ color: '#0073bb' }}>{item.title}</a>
              </td>
              <td style={{ padding: 8, fontSize: 12, color: '#666' }}>{item.publishedAt?.slice(0, 10)}</td>
              <td style={{ padding: 8, fontSize: 13, color: '#444' }}>{item.reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
